import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const ClientInductionList = ({ data, handleSort, getAllinvitedData }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>Invoice no.</Th>
              <Th>Client contact</Th>
              <Th>Fee type</Th>
              <Th>New/Renewal</Th>
              <Th>Invoice status</Th>
              <Th>Amount</Th>
              <Th>Raised date</Th>
              <Th>Payment date</Th>
            </Tr>
          </THead>
          <TBody>
            {data?.clientInvoice?.length > 0 &&
              data?.clientInvoice?.map((item, index) => {
                return (
                  <Tr key={index}>
                    <Td>{item?.invoice_no}</Td>
                    <Td>{item?.client_trading_name}</Td>
                    <Td>{item?.fee_type}</Td>
                    <Td>{item?.new_or_renewal || "-"}</Td>
                    <Td>
                      <span
                        className={
                          item?.invoice_status === "PAID"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            : item?.invoice_status === "OVERDUE"
                              ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                              : item?.invoice_status === "DRAFT"
                                ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                                : "badge bg-warning-50 text-warning-700 py-0.5 px-2 rounded-lg font-normal" // For UPCOMING or other
                        }
                      >
                        {item?.invoice_status?.charAt(0).toUpperCase() + item?.invoice_status?.slice(1).toLowerCase()}
                      </span>
                    </Td>
                    <Td>{item?.amount || 0}</Td>
                    <Td>
                      {item?.raised_date
                        ? moment(item?.raised_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                    <Td>
                      {item?.payment_date
                        ? moment(item?.payment_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default ClientInductionList;
